import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText, { ListItemTextProps } from '@mui/material/ListItemText';
import { ReactNode } from 'react';

import * as RewardStepsStyles from './RewardStep.styles';
import CheckedIcon from '../../../../assets/icons/CheckedIcon';

export interface RewardStepProps extends ListItemTextProps {
  stepNumber?: boolean | number;
  upcoming?: boolean;
  children?: ReactNode;
}

function RewardStep({ stepNumber, upcoming, children, ...props }: RewardStepProps) {
  const { classes: cardClasses } = RewardStepsStyles.cardClasses({ upcoming });
  const { classes: listItemClasses } = RewardStepsStyles.listItemClasses();
  const { classes: listItemIconClasses } = RewardStepsStyles.listItemIconClasses();
  const { classes: listTextClasses } = RewardStepsStyles.listTextClasses({ completed: !stepNumber });

  return (
    <Card classes={cardClasses} component={ListItem}>
      <ListItem disableGutters classes={listItemClasses} component={Box}>
        <ListItemIcon classes={listItemIconClasses}>
          {stepNumber ? <Chip color="primary" size="small" label={stepNumber} /> : <CheckedIcon />}
        </ListItemIcon>
        <ListItemText primaryTypographyProps={{ variant: 'h5' }} classes={listTextClasses} {...props} />
      </ListItem>
      {!!children && children}
    </Card>
  );
}

export default RewardStep;
